import { parseHttpDateHeader } from "@myvp/shared/src/functions/parse-http-date-header"
import { GetStudyHomeMetricsQuery } from "src/gql/graphql"
import { graphqlClient } from "@myvp/shared/src/functions/request"

export const getStudyHomeMetrics = async (globalSponsorStudyId: string) => {
  const query = /* GraphQL */ `
    query getStudyHomeMetrics(
      $input: GetStudyHomeMetricsInput!
      $listSiteStudiesInput: ListSiteStudiesInput!
    ) {
      getStudyHomeMetrics(input: $input) {
        studyName
        generatedAt
        sponsorStudyMetrics {
          countSites
          countParticipants
          completedSurveys
          missedSurveys
          eproCompliance
          eclinroCompliance
          hasEpro
          hasEclinro
          countAvailableEclinroSurveys
          countAvailableEproSurveys
          percentParticipantsWithSignaturesComplete
        }
        eproSiteMetrics {
          siteId
          siteNumber
          completedSurveys
          missedSurveys
          totalSurveys
          completedSurveysPercent
          totalAvailableSurveys
          countAvailableLessThanWeek
          countAvailableMoreThanWeek
        }
        eclinroSiteMetrics {
          siteId
          siteNumber
          completedSurveys
          missedSurveys
          totalSurveys
          completedSurveysPercent
          totalAvailableSurveys
          countAvailableLessThanWeek
          countAvailableMoreThanWeek
        }
        siteSignatureMetrics {
          siteId
          siteNumber
          percentParticipantsWithSignaturesComplete
          countParticipantsWithSignaturesComplete
          countParticipantsWithSignaturesRequired
        }
        studyStatus
        restrictedDataSetting
        dataChangesWaitingApprovalCount
      }
      getComplianceSettings {
        threshold
      }
      listSiteStudies(input: $listSiteStudiesInput) {
        siteStudiesByCountry {
          country
        }
      }
    }
  `
  const result = await graphqlClient.rawRequest(query, {
    input: {
      globalSponsorStudyId,
    },
    listSiteStudiesInput: {
      globalSponsorStudyId,
    },
  })
  const data = result.data as GetStudyHomeMetricsQuery
  const mostRecentDate = parseHttpDateHeader(result.headers)
  return {
    ...data.getStudyHomeMetrics,
    settings: data.getComplianceSettings,
    siteStudiesByCountry: data.listSiteStudies.siteStudiesByCountry,
    mostRecentDate,
  }
}
